<template>
  <div :class="classObj" class="app-wrapper" >
    <navbar @setLayout="setLayout" />
    <sidebar v-if="!sidebar" class="sidebar-container" />
    <div :class="{ hasTagsView: needTagsView}" class="main-container">
      <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
      <app-main /> 
      <settings ref="settingRef" />
    </div> 
  </div>
</template>

<script setup>
import {  computed,watchEffect,ref } from 'vue'
import { useRoute } from 'vue-router'
import { useWindowSize } from '@vueuse/core'
import Sidebar from './components/Sidebar/index.vue'
import { AppMain, Navbar, Settings } from './components'
import Breadcrumb from '@/components/Breadcrumb'
import useAppStore from '@/store/modules/app'
import useSettingsStore from '@/store/modules/settings'

const settingsStore = useSettingsStore()
const sidebar = computed(() => useAppStore().sidebar);

const device = computed(() => useAppStore().device);
const needTagsView = computed(() => settingsStore.tagsView);
const fixedHeader = computed(() => settingsStore.fixedHeader);

const classObj = computed(() => ({
  hideSidebar: !sidebar.value.opened,
  openSidebar: sidebar.value.opened,
  withoutAnimation: sidebar.value.withoutAnimation,
}))

console.log(classObj);

const { width, height } = useWindowSize();
const WIDTH = 992; // refer to Bootstrap's responsive design

watchEffect(() => {
  // if (device.value === 'mobile' && sidebar.value.opened) {
  //   useAppStore().closeSideBar({ withoutAnimation: false })
  // }
  // if (width.value - 1 < WIDTH) {
  //   useAppStore().closeSideBar({ withoutAnimation: true })
  // }
})

function handleClickOutside() {
  // useAppStore().closeSideBar({ withoutAnimation: false })
}

const settingRef = ref(null);
function setLayout() {
  // settingRef.value.openSetting();
}
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/mixin.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width:100%;
}

.sidebarHide .fixed-header {
  width: 100%;
}

.mobile .fixed-header {
  width: 100%;
}

</style>